import React from 'react'
import emptyScreenImage from "../../images/emptyScreen.png"

const EmptyScreen = ({children}) => {
  return (
    <div className='flex flex-col items-center justify-center gap-6 py-20'>
        <img src={emptyScreenImage} alt="empty screen" className='w-40 h-40' />
        {children}
    </div>
  )
}

export default EmptyScreen